module.exports = __webpack_public_path__ + "media/fonts/RecklessNeue-Regular-00386e72d9e3ab93b0e48d0ac50a22be.ttf";